import * as z from "zod";

/**
 * @param isEstimatedDeliveryRequired - Whether the delivery date must be provided.
 */
export const getLocationAndDeliverySchema = (isEstimatedDeliveryRequired?: boolean) => {
  return z
    .object({
      packaging: z.number({ message: "validation:boxtypeRequired" }),
      differentAddress: z.boolean().optional(),
      address: z.string().optional(),
      postCode: z.string().optional(),
      countryId: z.number({ message: "validation:countryRequired" }).optional(),
      estimatedDelivery: z
        .date({
          required_error: "validation:estimatedDeliveryRequired",
          invalid_type_error: "validation:estimatedDeliveryRequired",
        })
        .optional()
        .nullable(),
      place: z.string().optional(),
    })
    .superRefine(({ address, postCode, countryId, place, differentAddress, estimatedDelivery }, refinementContext) => {
      if (differentAddress) {
        if (!address) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "validation:addressRequired",
            path: ["address"],
          });
        }
        if (!postCode) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "validation:postCodeRequired",
            path: ["postCode"],
          });
        }
        if (!countryId) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "validation:countryRequired",
            path: ["countryId"],
          });
        }
        if (!place) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "validation:placeRequired",
            path: ["place"],
          });
        }
      }

      // Handle conditional requirement for estimatedDelivery
      if (isEstimatedDeliveryRequired && !estimatedDelivery) {
        refinementContext.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation:estimatedDeliveryRequired",
          path: ["estimatedDelivery"],
        });
      }
    });
};

// Update types to reflect the schema structure
export type LocationAndDeliveryFormInput = z.infer<ReturnType<typeof getLocationAndDeliverySchema>>;
